import React from 'react'

const Divider = () => {
  return (
    <div style={{ backgroundColor: '#D9D9D9', height: '1px', marginBlock: '1rem' }} />
  )
}

export default Divider
